// extracted by mini-css-extract-plugin
module.exports = {"loginCard":"login_loginCard__qdPni","formTitle":"login_formTitle__3_rm5","formItem":"login_formItem__3hd82","loginButton":"login_loginButton__3drJB","error":"login_error__1H0hU"};